"use client";

import React from "react";
import { Flower2, HeartHandshake, Stethoscope } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const features = [{
  title: "賦能照顧者",
  description: "提供專業指導與豐富資源，減輕家屬照護負擔，讓愛與專業護理並行不悖。",
  icon: Flower2
}, {
  title: "全人復康療癒",
  description: "整合物理與專職治療，不僅修復身體機能，更重塑受惠者的尊嚴與生活品質。",
  icon: Stethoscope
}, {
  title: "專業醫護支援",
  description: "由資深護理團隊領航，將專業的醫療照護直接送達家中，守護每一位家人的健康。",
  icon: HeartHandshake
}];
export default function NotJustGrooming() {
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="176350" id="憬於未來芯繫健康" className="relative overflow-hidden bg-background py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -left-[10%] -top-[20%] h-[60%] w-[50%] rounded-full bg-secondary/60 blur-[100px]" />
        <div className="absolute -bottom-[20%] -right-[10%] h-[60%] w-[50%] rounded-full bg-primary/10 blur-[100px]" />
      </div>

      <div className="container relative z-10 mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-2 lg:gap-24">
          {}
          <div ref={imgRef} className={cn("relative transition-all duration-1000 ease-out", isImgVisible ? "translate-x-0 opacity-100" : "-translate-x-12 opacity-0")}>
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-[2rem] border border-border/50 shadow-2xl shadow-primary/10">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606170/img/Image-24-scaled.png" alt="憬芯醫療 專業居家醫護環境" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/10 to-transparent" />
            </div>

            {}
            <div className="absolute -bottom-8 -right-4 max-w-[220px] rounded-3xl border border-border/50 bg-card p-6 shadow-xl sm:-right-8">
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                  <HeartHandshake className="h-5 w-5" />
                </div>
                <p className="text-sm font-medium leading-snug text-foreground">
                  深耕居家醫護領域，守護無數香港家庭
                </p>
              </div>
            </div>
          </div>

          {}
          <div ref={textRef} className={cn("flex flex-col transition-all duration-1000 delay-200 ease-out", isTextVisible ? "translate-x-0 opacity-100" : "translate-x-12 opacity-0")}>
            <Separator className="mb-8 h-1.5 w-16 rounded-full bg-primary" />
            
            <h2 className="font-serif text-4xl font-bold leading-[1.15] tracking-tight text-black md:text-5xl lg:text-6xl">
              <span className="text-primary">憬</span>於未來，<br />
              <span className="text-primary">芯</span>繫健康照護
            </h2>
            
            <p className="mt-6 text-lg leading-relaxed text-muted-foreground">
              憬芯醫療致力於為香港家庭提供全方位的居家醫護支援。我們由資深護理團隊領導，將專業照護帶到服務使用者身邊，讓您在熟悉的環境中尊嚴生活，並透過專業復康計劃治癒身體、更療癒心靈。
            </p>

            <div className="mt-10 flex flex-col gap-8">
              {features.map((feature, i) => <div key={i} data-index={i} className="flex items-start gap-5">
                  <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-secondary text-primary shadow-sm">
                    <feature.icon className="h-7 w-7" />
                  </div>
                  <div className="pt-1">
                    <h3 className="text-xl font-semibold text-foreground">
                      {feature.title}
                    </h3>
                    <p className="mt-2 text-base leading-relaxed text-muted-foreground">
                      {feature.description}
                    </p>
                  </div>
                </div>)}
            </div>

            <div className="mt-12">
              <Button asChild size="lg" className="h-14 rounded-full px-8 text-lg shadow-lg shadow-primary/20 transition-transform hover:-translate-y-1 bg-primary hover:bg-primary/90">
                <Link to="/NursingServicesPage">預約到戶醫護諮詢</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}